import { useTranslation } from 'react-i18next';

import Switch from '../../components/FormControls/Switch';
import Typography from '../../components/Typography';
import { i18nNS } from '../../i18n';
import EyeIcon from '../../icons/EyeIcon';
import SpinnerIcon from '../../icons/LoaderIcon';
import { ListItem, ListItemButton, ListItemIcon, ListItemText } from '../styles';
import useAccessibilityFeaturesVM from './vm';

const ACCESSIBILITY_FEATURES_LABEL_ID = 'accessibility-features';

const AccessibilityFeatures = () => {
  const { t } = useTranslation([i18nNS.SETTINGS]);

  const { isTogglingAccessibility, isAccessibilityOn, handleToggleAccessibility } =
    useAccessibilityFeaturesVM();

  return (
    <ListItem disableGutters disablePadding>
      <ListItemButton
        id="toggle-accessibility-features"
        onClick={handleToggleAccessibility}
        disabled={isTogglingAccessibility}
        aria-busy={isTogglingAccessibility}
        role="switch"
        aria-checked={isAccessibilityOn}
        aria-labelledby={ACCESSIBILITY_FEATURES_LABEL_ID}
      >
        <ListItemIcon>{isTogglingAccessibility ? <SpinnerIcon /> : <EyeIcon />}</ListItemIcon>
        <ListItemText>
          <Typography id={ACCESSIBILITY_FEATURES_LABEL_ID} variant="h6Regular" component="div">
            {t('screen_reader_support', { ns: i18nNS.SETTINGS })}
          </Typography>
        </ListItemText>
        <Switch edge="end" checked={isAccessibilityOn} readOnly />
      </ListItemButton>
    </ListItem>
  );
};

export default AccessibilityFeatures;
